<template>
  <!--  노션 링크 : https://www.notion.so/FeeguidancePage-20e3e9b304954d3e82c4d0d0d03d94b6 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="feeguidance_breadcrumb" />
    </div>

    <div class="header">
      <!--      <h1 class="overlay">GUIDE PROGRAM</h1>-->
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="contentDesc">
      <div class="title1">
        <h2>
          <strong>{{ $t('fee_title') }}</strong>
        </h2>
      </div>
    </div>

    <div class="container">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <b-tabs content-class="mt-3" fill>
            <b-tab :title="$t('tab1_title')" active>
              <b-container>
                <h5 class="mt-5 mb-3">{{ $t('tab1_subtitle1') }}</h5>

                <table class="web table table-borderless text-center">
                  <tbody>
                    <tr style="border-top: 2px solid; background-color: #f5f5f5">
                      <td class="right-bottom_color">{{ $t('tab1_table1_th1') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table1_th2') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table1_th3') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab1_table1_th4') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab1_table1_td1') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table1_td2') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table1_td3') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab1_table1_td4') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab1_table1_td5') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table1_td6') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table1_td7') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab1_table1_td8') }}</td>
                    </tr>
                  </tbody>
                </table>

                <table class="mobile table table-borderless text-center">
                  <tbody>
                    <tr style="border-top: 2px solid; border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab1_table1_th2') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table1_td1') }}</td>
                      <td>{{ $t('tab1_table1_td5') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table1_td2') }}</td>
                      <td>{{ $t('tab1_table1_td6') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab1_table1_th3') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table1_td1') }}</td>
                      <td>{{ $t('tab1_table1_td5') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table1_td3') }}</td>
                      <td>{{ $t('tab1_table1_td7') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab1_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table1_td1') }}</td>
                      <td>{{ $t('tab1_table1_td5') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table1_td4') }}</td>
                      <td>{{ $t('tab1_table1_td8') }}</td>
                    </tr>
                  </tbody>
                </table>

                <!--                <div class="mt-3">-->
                <!--                  <small>{{ $t('tab1_table1_bottom1') }}</small>-->
                <!--                </div>-->
                <div class="mt-3">
                  <small>{{ $t('tab1_table1_bottom2') }}</small>
                </div>
                <div class="text_align1">
                  <small>{{ $t('tab1_table1_bottom3') }}</small>
                </div>

                <h5 class="mt-5 mb-3">{{ $t('tab1_subtitle2') }}</h5>

                <table class="web table table-borderless text-center">
                  <tbody>
                    <tr style="border-top: 2px solid; background-color: #f5f5f5">
                      <td class="right-bottom_color">{{ $t('tab1_table2_th1') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table2_th2') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table2_th3') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab1_table2_th4') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab1_table2_td1') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table2_td2') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table2_td3') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab1_table2_td4') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab1_table2_td5') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table2_td6') }}</td>
                      <td class="right-bottom_color">{{ $t('tab1_table2_td7') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab1_table2_td8') }}</td>
                    </tr>
                  </tbody>
                </table>

                <table class="mobile table table-borderless text-center">
                  <tbody>
                    <tr style="border-top: 2px solid; border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab1_table2_th2') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table2_td1') }}</td>
                      <td>{{ $t('tab1_table2_td5') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table2_td2') }}</td>
                      <td>{{ $t('tab1_table2_td6') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab1_table2_th3') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table2_td1') }}</td>
                      <td>{{ $t('tab1_table2_td5') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table2_td3') }}</td>
                      <td>{{ $t('tab1_table2_td7') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab1_table2_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table2_td1') }}</td>
                      <td>{{ $t('tab1_table2_td5') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab1_table2_td4') }}</td>
                      <td>{{ $t('tab1_table2_td8') }}</td>
                    </tr>
                  </tbody>
                </table>

                <!--                <div class="mt-3">-->
                <!--                  <small>{{ $t('tab1_table2_bottom1') }}</small>-->
                <!--                </div>-->
                <div class="mt-3">
                  <small>{{ $t('tab1_table2_bottom2') }}</small>
                </div>
                <div class="mb-5 text_align1">
                  <small>{{ $t('tab1_table2_bottom3') }}</small>
                </div>
              </b-container>
            </b-tab>
            <b-tab :title="$t('tab2_title')">
              <b-container>
                <h5 class="mt-5 mb-3">{{ $t('tab2_subtitle1') }}</h5>
                <table class="table table-borderless text-center">
                  <tbody>
                    <tr style="border-top: 2px solid; background-color: #f5f5f5">
                      <td class="right-bottom_color" width="20%">{{ $t('tab2_table1_th1') }}</td>
                      <td class="right-bottom_color" width="40%">{{ $t('tab2_table1_th2') }}</td>
                      <td style="border-bottom: 1px solid #acacac" width="40%">{{ $t('tab2_table1_th3') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab2_table1_td1') }}</td>
                      <td class="right-bottom_color">{{ $t('tab2_table1_td2') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab2_table1_td3') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab2_table1_td4') }}</td>
                      <td class="right-bottom_color">{{ $t('tab2_table1_td5') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab2_table1_td6') }}</td>
                    </tr>
                  </tbody>
                </table>
                <h5 class="mt-5 mb-3">{{ $t('tab2_subtitle2') }}</h5>
                <table class="caddie-fee table table-borderless text-center">
                  <tbody>
                    <tr style="border-top: 2px solid; background-color: #f5f5f5">
                      <td class="right-bottom_color" width="20%">{{ $t('tab2_table2_th1') }}</td>
                      <td class="right-bottom_color" width="40%">{{ $t('tab2_table2_th2') }}</td>
                      <td style="border-bottom: 1px solid #acacac" width="40%">{{ $t('tab2_table2_th3') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab2_table2_td1') }}</td>
                      <td class="right-bottom_color">{{ $t('tab2_table2_td2') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab2_table2_td3') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab2_table2_td4') }}</td>
                      <td class="right-bottom_color">{{ $t('tab2_table2_td5') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab2_table2_td6') }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="mt-1">
                  <small>{{ $t('tab2_table1_bottom1') }}</small>
                </div>
                <div class="mb-5">
                  <small>{{ $t('tab2_table1_bottom2') }}</small>
                </div>
              </b-container>
            </b-tab>
            <b-tab :title="$t('tab3_title')">
              <b-container>
                <h5 class="mt-5 mb-3">{{ $t('tab3_subtitle1') }}</h5>

                <!--                <table class="web table table-borderless text-center">
                  <tbody>
                    <tr style="border-top: 2px solid; background-color: #f5f5f5">
                      <td class="right-bottom_color" colspan="2">테스트1</td>
                      <td class="right-bottom_color">테스트2</td>
                      <td class="right-bottom_color">테스트3</td>
                      <td class="right-bottom_color">테스트4</td>
                      <td style="border-bottom: 1px solid #acacac">테스트5</td>
                    </tr>
                    <tr>
                      <td rowspan="6" class="right-bottom_color align-middle">{{ $t('tab3_table1_td1') }}</td>
                      <td rowspan="2" class="right-bottom_color align-middle">{{ $t('tab3_table1_td2') }}</td>
                      <td rowspan="3" class="right-bottom_color">{{ $t('tab3_table1_td16') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td3') }}</td>
                      <td style="border-bottom: 1px solid #acacac">
                        {{ $t('tab3_table1_td19') }}
                      </td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td17') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td4') }}</td>
                      <td style="border-bottom: 1px solid #acacac">
                        {{ $t('tab3_table1_td20') }}
                      </td>
                    </tr>

                    <tr>
                      <td rowspan="3" class="right-bottom_color align-middle">{{ $t('tab3_table1_td6') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td22') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td3') }}</td>
                      <td style="border-bottom: 1px solid #acacac">
                        {{ $t('tab3_table1_td27') }}
                      </td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td23') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td4') }}</td>
                      <td style="border-bottom: 1px solid #acacac">
                        {{ $t('tab3_table1_td28') }}
                      </td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td24') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td5') }}</td>
                      <td style="border-bottom: 1px solid #acacac">
                        {{ $t('tab3_table1_td29') }}
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2" class="right-bottom_color align-middle">{{ $t('tab3_table1_td11') }}</td>
                      <td class="right-bottom_color align-middle">{{ $t('tab3_table1_td2') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td25') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td13') }}</td>
                      <td style="border-bottom: 1px solid #acacac">-</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color align-middle">{{ $t('tab3_table1_td6') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td26') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td15') }}</td>
                      <td style="border-bottom: 1px solid #acacac">-</td>
                    </tr>
                    &lt;!&ndash;                    <tr>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td3') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td4') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td5') }}</td>&ndash;&gt;
                    &lt;!&ndash;                    </tr>&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                DUNLOP XXIO SET 남성용 WEB 화면 삭제&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                <tr>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                  <td class="right-bottom_color">DUNLOP XXIO SET</td>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                  <td class="right-bottom_color">{{ $t('tab3_table1_td5') }}</td>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                  <td style="border-bottom: 1px solid #acacac"></td>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                </tr>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    <tr>&ndash;&gt;
                    &lt;!&ndash;                      <td rowspan="3" class="right-bottom_color align-middle">{{ $t('tab3_table1_td6') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">XXIO 11 SET</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td7') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td style="border-bottom: 1px solid #acacac">PUTTER : CLEVELAND</td>&ndash;&gt;
                    &lt;!&ndash;                    </tr>&ndash;&gt;
                    &lt;!&ndash;                    <tr>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">CALLAWAY SET</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td8') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td style="border-bottom: 1px solid #acacac"></td>&ndash;&gt;
                    &lt;!&ndash;                    </tr>&ndash;&gt;
                    &lt;!&ndash;                    <tr>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">YAMAHA SET</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td9') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td style="border-bottom: 1px solid #acacac">PUTTER : ODYSSEY</td>&ndash;&gt;
                    &lt;!&ndash;                    </tr>&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                DUNLOP XXIO SET 여성용 WEB 화면 삭제&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                <tr>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                  <td class="right-bottom_color">DUNLOP XXIO SET</td>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                  <td class="right-bottom_color">{{ $t('tab3_table1_td10') }}</td>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                  <td style="border-bottom: 1px solid #acacac"></td>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    &lt;!&ndash;                </tr>&ndash;&gt;&ndash;&gt;
                    &lt;!&ndash;                    <tr>&ndash;&gt;
                    &lt;!&ndash;                      <td rowspan="2" class="right-bottom_color align-middle">{{ $t('tab3_table1_td11') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td12') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">NIKE</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td13') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td style="border-bottom: 1px solid #acacac"></td>&ndash;&gt;
                    &lt;!&ndash;                    </tr>&ndash;&gt;
                    &lt;!&ndash;                    <tr>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td14') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">FOOT JOY</td>&ndash;&gt;
                    &lt;!&ndash;                      <td class="right-bottom_color">{{ $t('tab3_table1_td15') }}</td>&ndash;&gt;
                    &lt;!&ndash;                      <td style="border-bottom: 1px solid #acacac"></td>&ndash;&gt;
                    &lt;!&ndash;                    </tr>&ndash;&gt;
                  </tbody>
                </table>-->

                <table class="web table table-borderless text-center">
                  <tbody>
                    <!-- 헤더 1행 -->
                    <tr style="border-top: 2px solid; background-color: #f5f5f5">
                      <td rowspan="2" colspan="2" class="right-bottom_color align-middle">
                        {{ $t('tab3_table1_th1') }}
                      </td>
                      <td rowspan="2" class="right-bottom_color align-middle">{{ $t('tab3_table1_th2') }}</td>
                      <td rowspan="2" class="right-bottom_color align-middle">{{ $t('tab3_table1_th3') }}</td>
                      <td colspan="5" class="right-bottom_color align-middle">{{ $t('tab3_table1_th4') }}</td>
                      <td rowspan="2" style="border-bottom: 1px solid #acacac" class="align-middle">
                        {{ $t('tab3_table1_th10') }}
                      </td>
                    </tr>
                    <tr style="background-color: #f5f5f5">
                      <td class="right-bottom_color">{{ $t('tab3_table1_th5') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_th6') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_th7') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_th8') }}</td>
                      <td style="border-bottom: 1px solid #acacac" class="right-bottom_color">
                        {{ $t('tab3_table1_th9') }}
                      </td>
                    </tr>

                    <!-- 남성 : 대여채 (5행) -->
                    <tr>
                      <td rowspan="6" class="right-bottom_color align-middle">{{ $t('tab3_table1_td1') }}</td>
                      <td rowspan="5" class="right-bottom_color align-middle">{{ $t('tab3_table1_td3') }}</td>
                      <td rowspan="3" class="right-bottom_color align-middle" v-html="$t('tab3_table1_td5')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td12') }}</td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td17')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td25')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td33')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td41')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td47') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td13') }}</td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td18')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td26')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td34')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td41')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td47') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td14') }}</td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td19')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td27')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td35')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td42')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td47') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr>
                      <td rowspan="2" class="right-bottom_color align-middle" v-html="$t('tab3_table1_td6')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td12') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td20') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td28') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td36') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td43') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td48') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td15') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td21') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td29') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td37') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td43') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td49') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>

                    <!-- 남성 : 대여화 -->
                    <tr>
                      <td class="right-bottom_color align-middle">{{ $t('tab3_table1_td4') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td7') }}</td>
                      <td colspan="6" class="right-bottom_color">{{ $t('tab3_table1_td54') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td53') }}</td>
                    </tr>

                    <!-- 여성 : 대여채 (3행) -->
                    <tr>
                      <td rowspan="4" class="right-bottom_color align-middle">{{ $t('tab3_table1_td2') }}</td>
                      <td rowspan="3" class="right-bottom_color align-middle">{{ $t('tab3_table1_td3') }}</td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td8')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td16') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td22') }}</td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td30')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td38')"></td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td44')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td50') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td9')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td16') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td23') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td31') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td39') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td45') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td49') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td10')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td16') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td24') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td32') }}</td>
                      <td class="right-bottom_color" v-html="$t('tab3_table1_td40')"></td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td46') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td51') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td52') }}</td>
                    </tr>

                    <!-- 여성 : 대여화 -->
                    <tr>
                      <td class="right-bottom_color align-middle">{{ $t('tab3_table1_td4') }}</td>
                      <td class="right-bottom_color">{{ $t('tab3_table1_td11') }}</td>
                      <td colspan="6" class="right-bottom_color">{{ $t('tab3_table1_td54') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab3_table1_td53') }}</td>
                    </tr>
                  </tbody>
                </table>

                <table class="mobile table table-borderless text-center">
                  <tbody>
                    <!-- 대여채 남성 -->
                    <tr style="border-top: 2px solid; border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">
                        <strong v-html="`${$t('tab3_table1_td1')} - ${$t('tab3_table1_td3')}`"></strong>
                      </td>
                    </tr>

                    <!-- TaylorMade 스텔스2 -->
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2" v-html="$t('tab3_table1_td5')"></td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td12') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td
                        colspan="2"
                        v-html="
                          `${$t('tab3_table1_th5')} : ${$t('tab3_table1_td17')}<br />
                          ${$t('tab3_table1_th6')} : ${$t('tab3_table1_td25')}<br />
                          ${$t('tab3_table1_th7')} : ${$t('tab3_table1_td33')}<br />
                          ${$t('tab3_table1_th8')} : ${$t('tab3_table1_td41')}<br />
                          ${$t('tab3_table1_th9')} : ${$t('tab3_table1_td47')}`
                        "
                      ></td>
                    </tr>

                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td13') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td
                        colspan="2"
                        v-html="
                          `${$t('tab3_table1_th5')} : ${$t('tab3_table1_td18')}<br />${$t('tab3_table1_th6')} : ${$t(
                            'tab3_table1_td26',
                          )}<br />${$t('tab3_table1_th7')} : ${$t('tab3_table1_td34')}<br />${$t(
                            'tab3_table1_th8',
                          )} : ${$t('tab3_table1_td41')}<br />${$t('tab3_table1_th9')} : ${$t('tab3_table1_td47')}`
                        "
                      ></td>
                    </tr>

                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td14') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td
                        colspan="2"
                        v-html="
                          `${$t('tab3_table1_th5')} : ${$t('tab3_table1_td19')}<br />${$t('tab3_table1_th6')} : ${$t(
                            'tab3_table1_td27',
                          )}<br />${$t('tab3_table1_th7')} : ${$t('tab3_table1_td35')}<br />${$t(
                            'tab3_table1_th8',
                          )} : ${$t('tab3_table1_td42')}<br />${$t('tab3_table1_th9')} : ${$t('tab3_table1_td47')}`
                        "
                      ></td>
                    </tr>

                    <!-- PING+ XXIO 11 -->
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2" v-html="$t('tab3_table1_td6')"></td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td12') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td colspan="2">
                        {{ $t('tab3_table1_th5') }} : {{ $t('tab3_table1_td20') }}<br />
                        {{ $t('tab3_table1_th6') }} : {{ $t('tab3_table1_td28') }}<br />
                        {{ $t('tab3_table1_th7') }} : {{ $t('tab3_table1_td36') }}<br />
                        {{ $t('tab3_table1_th8') }} : {{ $t('tab3_table1_td43') }}<br />
                        {{ $t('tab3_table1_th9') }} : {{ $t('tab3_table1_td48') }}
                      </td>
                    </tr>

                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td15') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td colspan="2">
                        {{ $t('tab3_table1_th5') }} : {{ $t('tab3_table1_td21') }}<br />
                        {{ $t('tab3_table1_th6') }} : {{ $t('tab3_table1_td29') }}<br />
                        {{ $t('tab3_table1_th7') }} : {{ $t('tab3_table1_td37') }}<br />
                        {{ $t('tab3_table1_th8') }} : {{ $t('tab3_table1_td43') }}<br />
                        {{ $t('tab3_table1_th9') }} : {{ $t('tab3_table1_td49') }}
                      </td>
                    </tr>

                    <!-- 대여화 남성 -->
                    <tr style="border-top: 2px solid; border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">
                        <strong>{{ $t('tab3_table1_td1') }} - {{ $t('tab3_table1_td4') }}</strong>
                      </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th2') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td7') }}</td>
                      <td>{{ $t('tab3_table1_td53') }}</td>
                    </tr>

                    <!-- 대여채 여성 -->
                    <tr style="border-top: 2px solid; border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">
                        <strong>{{ $t('tab3_table1_td2') }} - {{ $t('tab3_table1_td3') }}</strong>
                      </td>
                    </tr>

                    <!-- Daiwa LP-423 -->
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2" v-html="$t('tab3_table1_td8')"></td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td16') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td
                        colspan="2"
                        v-html="
                          `${$t('tab3_table1_th5')} : ${$t('tab3_table1_td22')}<br />${$t('tab3_table1_th6')} : ${$t(
                            'tab3_table1_td30',
                          )}<br />${$t('tab3_table1_th7')} : ${$t('tab3_table1_td38')}<br />${$t(
                            'tab3_table1_th8',
                          )} : ${$t('tab3_table1_td44')}<br />${$t('tab3_table1_th9')} : ${$t('tab3_table1_td50')}`
                        "
                      ></td>
                    </tr>

                    <!-- XXIO11 -->
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_td9') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td16') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td colspan="2">
                        {{ $t('tab3_table1_th5') }} : {{ $t('tab3_table1_td23') }}<br />
                        {{ $t('tab3_table1_th6') }} : {{ $t('tab3_table1_td31') }}<br />
                        {{ $t('tab3_table1_th7') }} : {{ $t('tab3_table1_td39') }}<br />
                        {{ $t('tab3_table1_th8') }} : {{ $t('tab3_table1_td45') }}<br />
                        {{ $t('tab3_table1_th9') }} : {{ $t('tab3_table1_td49') }}
                      </td>
                    </tr>

                    <!-- Callaway -->
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2" v-html="$t('tab3_table1_td10')"></td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th3') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td16') }}</td>
                      <td>{{ $t('tab3_table1_td52') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">{{ $t('tab3_table1_th4') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td
                        colspan="2"
                        v-html="
                          `${$t('tab3_table1_th5')} : ${$t('tab3_table1_td24')}<br />${$t('tab3_table1_th6')} : ${$t(
                            'tab3_table1_td32',
                          )}<br />${$t('tab3_table1_th7')} : ${$t('tab3_table1_td40')}<br />${$t(
                            'tab3_table1_th8',
                          )} : ${$t('tab3_table1_td46')}<br />${$t('tab3_table1_th9')} : ${$t('tab3_table1_td51')}`
                        "
                      ></td>
                    </tr>

                    <!-- 대여화 여성 -->
                    <tr style="border-top: 2px solid; border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td colspan="2">
                        <strong>{{ $t('tab3_table1_td2') }} - {{ $t('tab3_table1_td4') }}</strong>
                      </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td style="border-right: 1px solid #acacac" width="50%">{{ $t('tab3_table1_th2') }}</td>
                      <td>{{ $t('tab3_table1_th10') }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac">
                      <td style="border-right: 1px solid #acacac">{{ $t('tab3_table1_td11') }}</td>
                      <td>{{ $t('tab3_table1_td53') }}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="mt-3 text_align1">
                  <small>{{ $t('tab3_table1_bottom1') }}</small>
                </div>
                <div class="text_align1">
                  <small>{{ $t('tab3_table1_bottom2') }}</small>
                </div>
                <div class="mb-5 text_align1">
                  <small>{{ $t('tab3_table1_bottom3') }}</small>
                </div>
              </b-container>
            </b-tab>
            <b-tab :title="$t('tab4_title')">
              <b-container>
                <h5 class="mt-5 mb-3">{{ $t('tab4_subtitle1') }}</h5>
                <div class="mb-3">
                  <small>{{ $t('tab4_subtitle1_desc1') }}</small>
                </div>

                <table class="web table table-borderless">
                  <tbody>
                    <tr class="text-center" style="border-top: 2px solid; background-color: #f5f5f5">
                      <td class="right-bottom_color">{{ $t('tab4_table1_th1') }}</td>
                      <td style="border-bottom: 1px solid #acacac">{{ $t('tab4_table1_th2') }}</td>
                    </tr>
                    <tr>
                      <td class="align-middle text-center right-bottom_color">{{ $t('tab4_table1_td1') }}</td>
                      <td class="" style="border-bottom: 1px solid #acacac">
                        <ul class="fee_badweather list-unstyled">
                          <li v-html="$t('tab4_table1_td2')"></li>
                          <p v-html="$t('tab4_table1_td3')"></p>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-center right-bottom_color align-middle">{{ $t('tab4_table1_td4') }}</td>
                      <td style="border-bottom: 1px solid #acacac">
                        <ul class="fee_badweather list-unstyled">
                          <li>{{ $t('tab4_table1_td5') }}</li>
                          <li>{{ $t('tab4_table1_td6') }}</li>
                          <li>{{ $t('tab4_table1_td7') }}</li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table class="mobile table table-borderless">
                  <tbody>
                    <tr class="text-center" style="border-top: 2px solid; background-color: #f5f5f5">
                      <td style="border-bottom: 1px solid #acacac">
                        {{ $t('tab4_table1_td1') }} - {{ $t('tab4_table1_th2') }}
                      </td>
                    </tr>
                    <tr>
                      <td class="" style="border-bottom: 1px solid #acacac">
                        <ul class="fee_badweather list-unstyled">
                          <li class="text_align2" v-html="$t('tab4_table1_td2')"></li>
                          <p class="text_align2" v-html="$t('tab4_table1_td3')"></p>
                        </ul>
                      </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
                      <td class="text-center align-middle">
                        {{ $t('tab4_table1_td4') }} - {{ $t('tab4_table1_th2') }}
                      </td>
                    </tr>
                    <tr>
                      <td style="border-bottom: 1px solid #acacac">
                        <ul class="fee_badweather list-unstyled">
                          <li>{{ $t('tab4_table1_td5') }}</li>
                          <li>{{ $t('tab4_table1_td6') }}</li>
                          <li>{{ $t('tab4_table1_td7') }}</li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div>
                  <small>{{ $t('tab4_table1_bottom1') }}</small
                  ><br />
                  <small>{{ $t('tab4_table1_bottom2') }}</small
                  ><br />
                  <small>{{ $t('tab4_table1_bottom3') }}</small>
                </div>

                <h5 class="mt-5 mb-2">{{ $t('tab4_subtitle2') }}</h5>
                <div class="mb-3">
                  <small>{{ $t('tab4_subtitle2_desc1') }}</small>
                </div>
                <h5 class="mt-3 text_align3">{{ $t('tab4_body_desc1') }}</h5>
                <h5 class="mt-3 mb-1 text_align3">{{ $t('tab4_body_desc2') }}</h5>
                <div class="mt-1 text_align4">
                  <small>{{ $t('tab4_body_desc3') }}</small>
                </div>
                <div class="text_align4">
                  <small>{{ $t('tab4_body_desc4') }}</small>
                </div>
                <div class="text_align4">
                  <small>{{ $t('tab4_body_desc5') }}</small>
                </div>
                <div class="text_align4">
                  <small>{{ $t('tab4_body_desc6') }}</small>
                </div>
                <div class="text_align4">
                  <small>{{ $t('tab4_body_desc7') }}</small>
                </div>
                <div class="text_align4">
                  <small>{{ $t('tab4_body_desc8') }}</small>
                </div>
                <div class="text_align4">
                  <small>{{ $t('tab4_body_desc9') }}</small>
                </div>
                <div class="mb-5 text_align4">
                  <small>{{ $t('tab4_body_desc10') }}</small>
                </div>
              </b-container>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'FeeguidancePage',
  data() {
    return {
      feeguidance_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'OPERATION GUIDE',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.feeguidance_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'OPERATION GUIDE',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
.operationguide_body_hedaer {
  margin-top: 40px;
  margin-bottom: 50px;
}

ul.fee_badweather li:before {
  content: 'ㆍ';
  display: inline-block;
  vertical-align: middle;
}
.right-bottom_color {
  border-right: 1px solid #acacac;
  border-bottom: 1px solid #acacac;
}
::v-deep a {
  color: #000 !important;
}
::v-deep .nav-tabs .nav-link.active {
  //margin: 0 3px;
  //margin-bottom: -1px;
  //padding-top: 16px;
  //padding-bottom: 12px;
  //background-color: #f9f9f9;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #000;
  font-weight: 600;
  //font-size: 17px;
  //line-height: 1.2;
}
.jpword {
  word-break: break-all;
}
.anotherword {
  .text_align1 {
    margin-left: 0.8rem;
    text-indent: -0.8rem;
    word-break: keep-all;
  }
  .text_align2 {
    margin-left: 0.4rem;
    text-indent: -0.4rem;
    word-break: keep-all;
  }
  .text_align3 {
    margin-left: 0.9rem;
    text-indent: -1.1rem;
    word-break: keep-all;
  }
  .text_align4 {
    margin-left: 1.7rem;
    text-indent: -0.9rem;
    word-break: keep-all;
  }
  word-break: keep-all;
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
    margin-bottom: 5rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
td {
  vertical-align: middle;
}
ul {
  margin: 0rem;
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Golf/operationguide_headerimage.png');
  }
  .web {
  }

  .mobile {
    display: none;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  h5 {
    font-size: 1rem !important;
    font-weight: 600 !important;
  }

  td {
    font-size: 0.9rem !important;
  }
  .web {
    display: none;
  }

  .mobile {
  }

  ::v-deep .nav-tabs {
    font-size: 0.8rem;
  }

  ::v-deep .nav-link {
    font-size: 0.8rem;
    padding: 1rem 0;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "요금안내",
    "fee_title": "요금 안내",
    "tab1_title": "입장료",
    "tab1_subtitle1": "회원제 / 18HOLE (EAST&WEST COURSE)",
    "tab1_table1_th1": "구분",
    "tab1_table1_th2": "월요일 ~ 금요일 1부",
    "tab1_table1_th3": "금요일2부 ~ 일요일 1부, 공휴일",
    "tab1_table1_th4": "일요일 2부",
    "tab1_table1_td1": "비회원",
    "tab1_table1_td2": "￦258,880",
    "tab1_table1_td3": "￦338,880",
    "tab1_table1_td4": "￦298,880",
    "tab1_table1_td5": "제주도민",
    "tab1_table1_td6": "￦194,160",
    "tab1_table1_td7": "￦254,160",
    "tab1_table1_td8": "￦224,160",
    "tab1_table1_bottom1": "※ 상기 요금은 5월 20일 部 적용 됩니다.",
    "tab1_table1_bottom2": "※ 제세금 21,120원(개별소비세, 교육세, 농어촌특별세, 부가세) 별도",
    "tab1_table1_bottom3": "※ 2인 플레이는 정회원 월요일~금요일 1부, 일요일 2부에 한하여 시행되며, 5인 플레이는 시행하지 않습니다.",
    "tab1_subtitle2": "비회원제 / 9HOLE (NORTH COURSE)",
    "tab1_table2_th1": "구분",
    "tab1_table2_th2": "월요일 ~ 금요일 1부",
    "tab1_table2_th3": "금요일2부 ~ 일요일 1부, 공휴일",
    "tab1_table2_th4": "일요일 2부",
    "tab1_table2_td1": "비회원",
    "tab1_table2_td2": "￦129,440",
    "tab1_table2_td3": "￦169,440",
    "tab1_table2_td4": "￦149,440",
    "tab1_table2_td5": "제주도민",
    "tab1_table2_td6": "￦64,720",
    "tab1_table2_td7": "￦84,720",
    "tab1_table2_td8": "￦74,720",
    "tab1_table2_bottom1": "※ 상기 요금은 5월 20일 部 적용 됩니다.",
    "tab1_table2_bottom2": "※ 제세금 21,120원(개별소비세, 교육세, 농어촌특별세, 부가세) 별도",
    "tab1_table2_bottom3": "※ 카트, 코스가이드 동반 라운드만 가능합니다. (셀프 라운드 이용 불가)",
    "tab2_title": "카트/코스가이드피",
    "tab2_subtitle1": "카트비",
    "tab2_table1_th1": "구분",
    "tab2_table1_th2": "18HOLE",
    "tab2_table1_th3": "9HOLE",
    "tab2_table1_td1": "일반",
    "tab2_table1_td2": "￦100,000",
    "tab2_table1_td3": "￦50,000",
    "tab2_table1_td4": "프리미엄리무진",
    "tab2_table1_td5": "￦220,000",
    "tab2_table1_td6": "￦110,000",
    "tab2_subtitle2": "코스가이드피",
    "tab2_table2_th1": "구분",
    "tab2_table2_th2": "18HOLE",
    "tab2_table2_th3": "9HOLE",
    "tab2_table2_td1": "1CADDIE 4BAGS",
    "tab2_table2_td2": "￦150,000",
    "tab2_table2_td3": "￦80,000",
    "tab2_table2_td4": "외국어 가능 코스가이드",
    "tab2_table2_td5": "￦200,000",
    "tab2_table2_td6": "￦100,000",
    "tab2_table1_bottom1": "※ 외국어(영어, 일본어, 중국어) 가능 코스가이드는 사전 배정제로 예약실로 문의 요망",
    "tab2_table1_bottom2": "※ 코스가이드피는 현장 지불 또는 카드 결제 가능(결제대행사수수료 4.4%)",

    "tab3_title": "렌탈",
    "tab3_subtitle1": "렌탈",
    "tab3_table1_th1": "구분",
    "tab3_table1_th2": "Brand",
    "tab3_table1_th3": "샤프트",
    "tab3_table1_th4": "구성",
    "tab3_table1_th5": "Driver",
    "tab3_table1_th6": "Wood",
    "tab3_table1_th7": "Utility",
    "tab3_table1_th8": "Iron",
    "tab3_table1_th9": "Putter",
    "tab3_table1_th10": "이용요금",
    "tab3_table1_td1": "남성",
    "tab3_table1_td2": "여성",
    "tab3_table1_td3": "대여채",
    "tab3_table1_td4": "대여화",
    "tab3_table1_td5": "TaylorMade<br/>테일러메이드<br/>스텔스2",
    "tab3_table1_td6": "PING+<br/>XXIO 11<br/>(핑/젝시오 11)",
    "tab3_table1_td7": "NIKE",
    "tab3_table1_td8": "Daiwa LP-423<br/>(다이와 온오프)",
    "tab3_table1_td9": "XXIO11<br/>(젝시오 11)",
    "tab3_table1_td10": "Callaway<br/>(캘러웨이)",
    "tab3_table1_td11": "FOOT JOY",
    "tab3_table1_td12": "R",
    "tab3_table1_td13": "SR/R",
    "tab3_table1_td14": "S",
    "tab3_table1_td15": "SR",
    "tab3_table1_td16": "L",
    "tab3_table1_td17": "TaylorMade 스텔스<br/>(10.5° R)",
    "tab3_table1_td18": "TaylorMade 스텔스2<br/>(10.5° SR)",
    "tab3_table1_td19": "TaylorMade 스텔스2<br/>(10.5° S)",
    "tab3_table1_td20": "PING G425-(10.5°R)",
    "tab3_table1_td21": "PING G425-(10.5°SR)",
    "tab3_table1_td22": "Daiwa LP-423-(11.5°/L)",
    "tab3_table1_td23": "XXIO11-(10.5°/L)",
    "tab3_table1_td24": "Callaway-(11.5°/L)",
    "tab3_table1_td25": "TaylorMade 스텔스2<br/>5#(18° R)",
    "tab3_table1_td26": "TaylorMade 스텔스2<br/>5#(18° SR)",
    "tab3_table1_td27": "TaylorMade 스텔스2<br/>5#(18° S)",
    "tab3_table1_td28": "PING G425-(5#/R)",
    "tab3_table1_td29": "PING G425-(5#/SR)",
    "tab3_table1_td30": "Daiwa LP-423<br/>4#(17.5°/L)",
    "tab3_table1_td31": "XXIO11-3#(16°/L)",
    "tab3_table1_td32": "Callaway-5#(21°,L)",
    "tab3_table1_td33": "TaylorMade 스텔스2<br/>4H(22°R)",
    "tab3_table1_td34": "TaylorMade 스텔스2<br/>4H(22° R)",
    "tab3_table1_td35": "TaylorMade 스텔스2<br/>4H(22° S)",
    "tab3_table1_td36": "PING G425 5H-(26°/R)",
    "tab3_table1_td37": "PING G425 5H-(26°/SR)",
    "tab3_table1_td38": "Daiwa LP-423<br/>5H(24°/L)",
    "tab3_table1_td39": "XXIO11-3H(19°/L)",
    "tab3_table1_td40": "Callaway<br/>5#,6#(24°,29°/L)",
    "tab3_table1_td41": "TaylorMade 스텔스2<br/>Graphite R (5~9,P,A,S)",
    "tab3_table1_td42": "TaylorMade 스텔스2<br/>Steel (5~9,P,A,S)",
    "tab3_table1_td43": "XXIO11-Graphite (5~9,P,A,S)",
    "tab3_table1_td44": "Daiwa LP-423<br/>Graphite L (6~9,P,A,S)",
    "tab3_table1_td45": "XXIO-Graphite L (6~9,P,A,S)",
    "tab3_table1_td46": "Callaway-Graphite L (7~9,P,S)",
    "tab3_table1_td47": "Odyssey 34inch",
    "tab3_table1_td48": "Cleveland Huntington / Honma / Odyssey",
    "tab3_table1_td49": "Cleveland Huntington Beach",
    "tab3_table1_td50": "Daiwa LP-423",
    "tab3_table1_td51": "Callaway Putter",
    "tab3_table1_td52": "50,000원",
    "tab3_table1_td53": "5,000원",
    "tab3_table1_td54": "-",
    "tab3_table1_bottom1": "※ 대여품은 구성된 세트로 제공되며, 구성 변경 및 개별 선택은 불가합니다. 예약 전 사전 확인해 주시기 바랍니다.",
    "tab3_table1_bottom2": "※ 선 사용 예약 요청 건에 따라 원하시는 클럽의 대여가 제한될 수 있습니다.",
    "tab3_table1_bottom3": "※ 상기 이용요금은 사전 예고없이 변경될 수 있습니다.",

    "tab4_title": "악천후 시",
    "tab4_subtitle1": "악천후 시 이용요금 안내",
    "tab4_subtitle1_desc1": "기상상태가 불투명한 날 내장하시어 라운딩 도중에 기상악화로 중단될 경우 아래와 같이 입장료 및 카트대여료, 코스가이드피가 적용 되오니 참고하시기 바랍니다.",
    "tab4_table1_th1": "구분",
    "tab4_table1_th2": "요금부과",
    "tab4_table1_td1": "입장료 및 카트대여료",
    "tab4_table1_td2": "2홀 이상 : (이용요금<sup>1)</sup> – 기본요금<sup>2)</sup>) * (기 이용한 홀수<sup>3)</sup> / 전체 홀 수)",
    "tab4_table1_td3": "&nbsp&nbsp&nbsp※ 단, 1홀을 마치지 못한 경우 기본요금이 부과됩니다.",
    "tab4_table1_td4": "코스가이드피",
    "tab4_table1_td5": "1홀 이상 ~ 5홀 이하 8만원이 부과됩니다.",
    "tab4_table1_td6": "6홀 이상 ~ 9홀 이하 9만원이 부과됩니다.",
    "tab4_table1_td7": "10홀 이상 15만원이 부과됩니다.",
    "tab4_table1_bottom1": "1) 이용요금에는 코스가이드피를 제외한 개별 특별 소비세 등이 포함되어 있습니다.",
    "tab4_table1_bottom2": "2) 기본요금은 락커, 샤워실 등 클럽하우스 시설 이용에 부과되는 요금으로 20,000원이 부과됩니다.",
    "tab4_table1_bottom3": "3) 이용 홀수의 기준은 홀 아웃을 기준으로 합니다.",
    "tab4_subtitle2": "악천후 기준 내용",
    "tab4_subtitle2_desc1": "악천후 시 아래의 기준에 따라 라운드 취소 및 일시 정지됩니다.",
    "tab4_body_desc1": "1. 악천후로 인하여 한 팀도 9홀 이상 진행하지 못하거나, 예약취소가 50% 이상인 경우",
    "tab4_body_desc2": "2. 악천후로 인하여 정상적인 플레이로 경기운영팀에서 인정키 어려운 경우",
    "tab4_body_desc3": "1) 스루더 그린 전 지역에 물이 차서 당장 플레이하기 어려운 경우",
    "tab4_body_desc4": "2) 대부분의 홀 벙커에 물이 차서 당장 플레이하기 어려운 경우",
    "tab4_body_desc5": "3) 코스 내 안개로 인해 세컨 샷 지점 시야 확보가 안 되는 경우",
    "tab4_body_desc6": "4) 강수량(눈)이 일시에 많아져 플레이들이 정상적인 플레이를 할 수 없는 경우",
    "tab4_body_desc7": "5) 바람에 의해 스루더 그린 및 그린 위의 공이 움직이는 경우 (풍속 11m/s 이상 수준)",
    "tab4_body_desc8": "6) 낙뢰의 위치가 가까워져 플레이어의 안전이 보장되지 않는 경우",
    "tab4_body_desc9": "※ 1) ~ 5)의 경우 일시 정지 후 날씨 상황에 따라 재개 및 악천후 적용 처리됩니다.",
    "tab4_body_desc10": "※ 체감온도에 의한 경우는 악천후 적용이 되지 않습니다."
  },
  "en": {
    "breadcrumb": "Rate Information",
    "fee_title": "Rate Information",
    "tab1_title": "Admission fee",
    "tab1_subtitle1": "Membership System / 18Hole (East&West Course)",
    "tab1_table1_th1": "Category",
    "tab1_table1_th2": "Monday ~ Part1 on Friday",
    "tab1_table1_th3": "Part2 on Friday ~ Part1 on Sunday, Public Holiday",
    "tab1_table1_th4": "Part2 on Sunday",
    "tab1_table1_td1": "Non-members",
    "tab1_table1_td2": "KRW 258,880",
    "tab1_table1_td3": "KRW 338,880",
    "tab1_table1_td4": "KRW 298,880",
    "tab1_table1_td5": "Jeju residents",
    "tab1_table1_td6": "KRW 194,160",
    "tab1_table1_td7": "KRW 254,160",
    "tab1_table1_td8": "KRW 224,160",
    "tab1_table1_bottom1": "※ This fee will be applied from May 20th",
    "tab1_table1_bottom2": "※ Public charges and taxes KRW 21,120 (individual consumption tax, education tax, special tax for rural development, value added tax) excluded",
    "tab1_table1_bottom3": "※ 2-person play is only enforced on Monday~Part1 on Friday and Part2 on Sunday of regular members, and 5-person play are restricted.",
    "tab1_subtitle2": "General System / 9Hole (North Course)",
    "tab1_table2_th1": "Category",
    "tab1_table2_th2": "Monday ~ Part1 on Friday",
    "tab1_table2_th3": "Part2 on Friday ~ Part1 on Sunday, Public Holiday",
    "tab1_table2_th4": "Part2 on Sunday",
    "tab1_table2_td1": "Non-members",
    "tab1_table2_td2": "KRW 129,440",
    "tab1_table2_td3": "KRW 169,440",
    "tab1_table2_td4": "KRW 149,440",
    "tab1_table2_td5": "Jeju residents",
    "tab1_table2_td6": "￦64,720",
    "tab1_table2_td7": "￦84,720",
    "tab1_table2_td8": "￦74,720",
    "tab1_table2_bottom1": "※ This fee will be applied from May 20th",
    "tab1_table2_bottom2": "※  Public charges and taxes KRW 21,120 (individual consumption tax, education tax, special tax for rural development, value added tax) excluded",
    "tab1_table2_bottom3": "※ Only round with cart and caddie is allowed. (Self-round not available)",
    "tab2_title": "Cart/Caddie Fee",
    "tab2_subtitle1": "Cart Fee",
    "tab2_table1_th1": "Category",
    "tab2_table1_th2": "18HOLE",
    "tab2_table1_th3": "9HOLE",
    "tab2_table1_td1": "Golf Cart",
    "tab2_table1_td2": "KRW 100,000",
    "tab2_table1_td3": "KRW 50,000",
    "tab2_table1_td4": "Premium Limousine Cart",
    "tab2_table1_td5": "KRW 220,000",
    "tab2_table1_td6": "KRW 110,000",
    "tab2_subtitle2": "Caddie Fee",
    "tab2_table2_th1": "Category",
    "tab2_table2_th2": "18HOLE",
    "tab2_table2_th3": "9HOLE",
    "tab2_table2_td1": "1CADDIE 4BAGS",
    "tab2_table2_td2": "KRW 150,000",
    "tab2_table2_td3": "KRW 80,000",
    "tab2_table2_td4": "Multilingual Caddie",
    "tab2_table2_td5": "KRW 200,000",
    "tab2_table2_td6": "KRW 100,000",
    "tab2_table1_bottom1": "※ Multilingual(EN, JP, CN) caddies are pre-assigned, contact Pinx reservation team.",
    "tab2_table1_bottom2": "※ The caddie fee is payable on-site or by credit card (a 4.4% transaction fee applies for card payments)",

    "tab3_title": "Rental",
    "tab3_subtitle1": "Rental",
    "tab3_table1_th1": "Category",
    "tab3_table1_th2": "Brand",
    "tab3_table1_th3": "Shaft",
    "tab3_table1_th4": "Composition",
    "tab3_table1_th5": "Driver",
    "tab3_table1_th6": "Wood",
    "tab3_table1_th7": "Utility",
    "tab3_table1_th8": "Iron",
    "tab3_table1_th9": "Putter",
    "tab3_table1_th10": "Rate",
    "tab3_table1_td1": "For Men",
    "tab3_table1_td2": "For Women",
    "tab3_table1_td3": "Rental Club",
    "tab3_table1_td4": "Rental Shoes",
    "tab3_table1_td5": "TaylorMade<br/>STEALTH 2",
    "tab3_table1_td6": "PING+<br/>XXIO 11",
    "tab3_table1_td7": "NIKE",
    "tab3_table1_td8": "Daiwa<br/>ON-OFF LP-423",
    "tab3_table1_td9": "XXIO11",
    "tab3_table1_td10": "Callaway",
    "tab3_table1_td11": "FOOT JOY",
    "tab3_table1_td12": "R",
    "tab3_table1_td13": "SR/R",
    "tab3_table1_td14": "S",
    "tab3_table1_td15": "SR",
    "tab3_table1_td16": "L",
    "tab3_table1_td17": "TaylorMade (10.5° R)",
    "tab3_table1_td18": "TaylorMade (10.5° SR)",
    "tab3_table1_td19": "TaylorMade (10.5° S)",
    "tab3_table1_td20": "PING G425-(10.5°R)",
    "tab3_table1_td21": "PING G425-(10.5°SR)",
    "tab3_table1_td22": "Daiwa LP-423-(11.5°/L)",
    "tab3_table1_td23": "XXIO11-(10.5°/L)",
    "tab3_table1_td24": "Callaway-(11.5°/L)",
    "tab3_table1_td25": "TaylorMade 5#(18° R)",
    "tab3_table1_td26": "TaylorMade 5#(18° SR)",
    "tab3_table1_td27": "TaylorMade 5#(18° S)",
    "tab3_table1_td28": "PING G425-(5#/R)",
    "tab3_table1_td29": "PING G425-(5#/SR)",
    "tab3_table1_td30": "Daiwa LP-423<br/>4#(17.5°/L)",
    "tab3_table1_td31": "XXIO11-3#(16°/L)",
    "tab3_table1_td32": "Callaway-5#(21°,L)",
    "tab3_table1_td33": "TaylorMade 4H(22°R)",
    "tab3_table1_td34": "TaylorMade 4H(22° R)",
    "tab3_table1_td35": "TaylorMade 4H(22° S)",
    "tab3_table1_td36": "PING G425 5H-(26°/R)",
    "tab3_table1_td37": "PING G425 5H-(26°/SR)",
    "tab3_table1_td38": "Daiwa LP-423<br/>5H(24°/L)",
    "tab3_table1_td39": "XXIO11-3H(19°/L)",
    "tab3_table1_td40": "Callaway<br/>5#,6#(24°,29°/L)",
    "tab3_table1_td41": "TaylorMade Graphite R<br/>(5~9,P,A,S)",
    "tab3_table1_td42": "TaylorMade Steel (5~9,P,A,S)",
    "tab3_table1_td43": "XXIO11-Graphite (5~9,P,A,S)",
    "tab3_table1_td44": "Daiwa LP-423<br/>Graphite L (6~9,P,A,S)",
    "tab3_table1_td45": "XXIO-Graphite L (6~9,P,A,S)",
    "tab3_table1_td46": "Callaway-Graphite L (7~9,P,S)",
    "tab3_table1_td47": "Odyssey 34inch",
    "tab3_table1_td48": "Cleveland Huntington / Honma / Odyssey",
    "tab3_table1_td49": "Cleveland Huntington Beach",
    "tab3_table1_td50": "Daiwa LP-423",
    "tab3_table1_td51": "Callaway Putter",
    "tab3_table1_td52": "KRW 50,000",
    "tab3_table1_td53": "KRW 5,000",
    "tab3_table1_td54": "-",
    "tab3_table1_bottom1": "※ Rental items are provided as pre-configured sets, and changes to the composition or individual selections are not permitted. Please check in advance before making a reservation.",
    "tab3_table1_bottom2": "※ Depending on the reservation request for prior use, the rental of the club may be restricted.",
    "tab3_table1_bottom3": "※ The rates above are subject to change without prior notice.",

    "tab4_title": "In bad weather",
    "tab4_subtitle1": "Usage Fee during Inclement Weather",
    "tab4_subtitle1_desc1": "If your rounding is canceled due to inclement whether, please note that the following rates apply for admission, cart rental and caddie fees.",
    "tab4_table1_th1": "Fees",
    "tab4_table1_th2": "Charges",
    "tab4_table1_td1": "Admission and Cart Rental Fees",
    "tab4_table1_td2": "2 or more holes : (usage fee<sup>1)</sup> – basic fee<sup>2)</sup>) * (number of holes used<sup>3)</sup> / total number of holes)",
    "tab4_table1_td3": "&nbsp&nbsp&nbsp※ If you have not completed 1 hole, basic fee will be charged.",
    "tab4_table1_td4": "Caddie Fees",
    "tab4_table1_td5": "1~5 holes: 80,000 KRW",
    "tab4_table1_td6": "6~9 holes: 90,000 KRW",
    "tab4_table1_td7": "10 holes or more: 150,000 KRW",
    "tab4_table1_bottom1": "1) The usage fee includes individual special consumption tax excluding caddie fees.",
    "tab4_table1_bottom2": "2) The basic fee is 20,000 KRW for the use of clubhouse facilities such as lockers and shower rooms.",
    "tab4_table1_bottom3": "3) The number of holes used is based on hole out.",
    "tab4_subtitle2": "Criteria for Severe Weather Conditions",
    "tab4_subtitle2_desc1": "In case of severe weather, the round will be canceled and paused according to the following criteria.",
    "tab4_body_desc1": "1. If no team could progress more than 9 holes due to severe weather, or over 50% of reservation is cancelled",
    "tab4_body_desc2": "2. If it is difficult for the operating team to recognize the game as a normal play due to severe weather.",
    "tab4_body_desc3": "1) If it is difficult to play immediately as the whole through-the-green area is filled with water.",
    "tab4_body_desc4": "2) If it is difficult to play immediately as most of the hole bunkers are filled with water.",
    "tab4_body_desc5": "3) If the second shot position cannot be secured due to the fog in the course",
    "tab4_body_desc6": "4) If it is difficult to play normally due to sudden increase of precipitation (snowfall)",
    "tab4_body_desc7": "5) If the wind moves the ball within the three-the-green area or on the green (when the wind velocity is 11m/s or greater)",
    "tab4_body_desc8": "6) If the safety of the player is not guaranteed due to approaching thunderbolt",
    "tab4_body_desc9": "※ In case of 1) - 5), the game will be paused and will be resumed or the severe weather rates will be applied depending on weather conditions.",
    "tab4_body_desc10": "※ Severe weather rates will not be applied based on wind chill."
  },
  "ja": {
    "breadcrumb": "料金のご案内",
    "fee_title": "料金のご案内",
    "tab1_title": "グリーンフィー",
    "tab1_subtitle1": "会員制 / 18ホール(East&West Course)",
    "tab1_table1_th1": "パート",
    "tab1_table1_th2": "月曜日 ~ 金曜日1部",
    "tab1_table1_th3": "金曜日2部 ~ 日曜日1部、休日",
    "tab1_table1_th4": "日曜日2部",
    "tab1_table1_td1": "非会員",
    "tab1_table1_td2": "￦228,880",
    "tab1_table1_td3": "￦298,880",
    "tab1_table1_td4": "￦268,880",
    "tab1_table1_td5": "済州道民",
    "tab1_table1_td6": "￦198,880",
    "tab1_table1_td7": "￦268,880",
    "tab1_table1_td8": "￦238,880",
    "tab1_table1_bottom1": "※ 2022.3.1より上記料金が適用されます。",
    "tab1_table1_bottom2": "※ 諸税（個別消費税、教育税、農漁村特別税、付加税）別途。",
    "tab1_table1_bottom3": "※ 2人プレイは正会員対象 月曜日〜金曜日1部、日曜日2部 に限り実施され、5人プレイでは実施しません。",
    "tab1_subtitle2": "一般制 / 9ホール(North Course)",
    "tab1_table2_th1": "パート",
    "tab1_table2_th2": "月曜日 ~ 金曜日1部",
    "tab1_table2_th3": "金曜日2部 ~ 日曜日1部、休日",
    "tab1_table2_th4": "日曜日2部",
    "tab1_table2_td1": "非会員",
    "tab1_table2_td2": "￦114,440",
    "tab1_table2_td3": "￦149,440",
    "tab1_table2_td4": "￦134,440",
    "tab1_table2_td5": "済州道民",
    "tab1_table2_td6": "￦99,440",
    "tab1_table2_td7": "￦134,440",
    "tab1_table2_td8": "￦119,440",
    "tab1_table2_bottom1": "※ 2022.3.1より上記料金が適用されます。",
    "tab1_table2_bottom2": "※ カートとキャディ付きのラウンドのみが許可されます。（セルフラウンドは利用できません）",
    "tab2_title": "カート/キャディーフィー",
    "tab2_subtitle1": "カート費",
    "tab2_table1_th1": "パート",
    "tab2_table1_th2": "18HOLE",
    "tab2_table1_th3": "9HOLE",
    "tab2_table1_td1": "Golf Cart",
    "tab2_table1_td2": "￦100,000",
    "tab2_table1_td3": "￦50,000",
    "tab2_table1_td4": "Premium Limousine Cart",
    "tab2_table1_td5": "￦220,000",
    "tab2_table1_td6": "￦110,000",
    "tab2_subtitle2": "キャディーフィー",
    "tab2_table2_th1": "パート",
    "tab2_table2_th2": "18HOLE",
    "tab2_table2_th3": "9HOLE",
    "tab2_table2_td1": "1CADDIE 4BAGS",
    "tab2_table2_td2": "KRW 150,000",
    "tab2_table2_td3": "KRW 80,000",
    "tab2_table2_td4": "Multilingual Caddie",
    "tab2_table2_td5": "KRW 200,000",
    "tab2_table2_td6": "KRW 100,000",
    "tab2_table1_bottom1": "※ Multilingual(EN, JP, CN) caddies are pre-assigned, contact Pinx reservation team.",
    "tab2_table1_bottom2": "※ Pay caddie fee directly to the caddie",
    "tab3_title": "レンタル",
    "tab3_subtitle1": "レンタル",
    "tab3_table1_th1": "パート",
    "tab3_table1_th2": "製品名",
    "tab3_table1_th3": "レンタル料",
    "tab3_table1_th4": "備考",
    "tab3_table1_td1": "レンタル クラブ",
    "tab3_table1_td2": "男性用",
    "tab3_table1_td3": "KRW 50,000",
    "tab3_table1_td4": "KRW 50,000",
    "tab3_table1_td5": "KRW 30,000",
    "tab3_table1_td6": "女性用",
    "tab3_table1_td7": "KRW 50,000",
    "tab3_table1_td8": "KRW 50,000",
    "tab3_table1_td9": "KRW 50,000",
    "tab3_table1_td10": "KRW 30,000",
    "tab3_table1_td11": "レンタルシューズ シューズ",
    "tab3_table1_td12": "男性用",
    "tab3_table1_td13": "KRW 5,000",
    "tab3_table1_td14": "女性用",
    "tab3_table1_td15": "KRW 5,000",
    "tab3_table1_td16": "TAYLORMADE 스텔스2",
    "tab3_table1_td17": "PING/XXIO 11",
    "tab3_table1_td18": "TAYLORMADE S (왼손)",
    "tab3_table1_td19": "DRIVER : R/SR, UTILITY : R/S, IRON : R. PUTTER : ODYSSEY 34inch",
    "tab3_table1_td20": "DRIVER : PING R/SR, IRON : XXIO11, PUTTER : CLEVELAND / ODYSSEY / HONMA",
    "tab3_table1_td21": "DRIVER : S, IRON : Steel",
    "tab3_table1_td22": "DAIWA ON-OFF LP-423",
    "tab3_table1_td23": "XXIO 11",
    "tab3_table1_td24": "CALLAWAY",
    "tab3_table1_td25": "NIKE",
    "tab3_table1_td26": "FOOT JOY",
    "tab3_table1_td27": "FULL SET",
    "tab3_table1_td28": "PUTTER : CLEVELAND",
    "tab3_table1_td29": "FULL SET",
    "tab3_table1_bottom1": "※ 先に予約が入っている場合には希望のクラブをご用意できない場合があります。",
    "tab3_table1_bottom2": "※ 上記の料金は予告なく変更になることがあります。",

    "tab4_title": "天候不良時",
    "tab4_subtitle1": "天候不良時の利用料金のご案内",
    "tab4_subtitle1_desc1": "天候の状態が不透明な日にご来場なさりプレーの途中で天候の悪化によりクローズとなった場合には下記の通りグリーンフィーおよびカートフィーが適用されますのでご参考ください。",
    "tab4_table1_th1": "パート",
    "tab4_table1_th2": "料金",
    "tab4_table1_td1": "グリーンフィーおよびカートフィー",
    "tab4_table1_td2": "2ホール以下のプレーの場合には無料です。（ただし、個別消費税は申し受けます）",
    "tab4_table1_td3": "3ホール以上9ホール以下のプレーは9ホール料金を申し受けます。",
    "tab4_table1_td4": "10ホール以上プレーなさった場合には全額を申し受けます。",
    "tab4_table1_td5": "キャディーフィー",
    "tab4_table1_td6": "1ホール以上 ~ 5ホール以下KRW80,000 が賦課されます。",
    "tab4_table1_td7": "6ホール以上 ~ 9ホール以下KRW90,000が賦課されます。",
    "tab4_table1_td8": "10ホール以上 KRW150,000が賦課されます。",
    "tab4_table1_bottom1": "※ ホール基準はホールアウトを基準にします。",
    "tab4_subtitle2": "天候不良の基準",
    "tab4_subtitle2_desc1": "天候不良の場合には下記の基準によりプレーのキャンセルおよび一時中断となります。",
    "tab4_body_desc1": "1. 天候不良により1組も9ホール以上プレーできなかった場合や予約キャンセルが50％以上の場合",
    "tab4_body_desc2": "2. 天候不良により正常なプレーとして競技運営委員会で認めることが困難な場合",
    "tab4_body_desc3": "1) スルーザグリーンの全地域が水に浸ってすぐにプレーすることが困難な場合",
    "tab4_body_desc4": "2) 大部分のホールのバンカーが水に浸ってすぐにプレーすることが困難な場合",
    "tab4_body_desc5": "3) コース内の霧によりセカンドショット地点の視界の確保ができない場合",
    "tab4_body_desc6": "4) 降雨量（雪）が一時に多くなりプレーヤーが正常なプレーができない場合。",
    "tab4_body_desc7": "5) 風によりスルーザグリーンおよびグリーン上のボールが動く場合（風速11m/s以上レベル）",
    "tab4_body_desc8": "6) 落雷の位置が近くなりプレーヤーの安全が保障されない場合",
    "tab4_body_desc9": "※ 1）～5）の場合には一時中断後の天候の状況により再開または天候不良が適用されます。",
    "tab4_body_desc10": "※ 体感温度は天候不良が適用となりません。"
  }
}
</i18n>
